/* eslint-disable react/no-unused-state, no-unused-vars */

import IconButton from '@material-ui/core/IconButton'
import Delete from '@material-ui/icons/Delete'
import { PureComponent } from 'react'
import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'
import Avatar from '../Avatar'

const StyledItem = styled.div`
  margin-bottom: 10px !important;
  display: flex;
  align-items: center;
`

const StyledAvatar = styled(Avatar)`
  margin-right: 10px !important;
`

const StyledRemoveIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: ${rem(18)};
  margin-left: auto !important;
`

const StyledIconButton = styled(IconButton)`
  color: ${theme.colors.darkGrey};
  &:hover {
    color: ${theme.colors.red} !important;
  }
`

class InputFieldItem extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { value: '' }
  }

  render() {
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { value, onDelete, classes, disableDelete, ...rest } = this.props

    return (
      <StyledItem>
        <StyledAvatar shape="circle" size="small" name={value.toUpperCase()} single />
        {value}

        <StyledRemoveIcon>
          <StyledIconButton disabled={disableDelete} classes={{ root: classes.button }} onClick={onDelete}>
            {!disableDelete && <Delete className={classes.icon} />}
          </StyledIconButton>
        </StyledRemoveIcon>
      </StyledItem>
    )
  }
}

InputFieldItem.defaultProps = {}

InputFieldItem.displayName = 'InputFieldItem'
export default InputFieldItem
